import { createApiAction } from 'redux/redux-actions';
import restApis from '../restApis';
import {
  LIST_BRANDS,
  LIST_FAQS,
  LIST_FEATURES,
  LIST_GLOBALS,
  LIST_PACKS,
  LIST_PERMISSIONS,
  LIST_ROLES,
  LIST_TAGS,
  LIST_TEAM_MEMBERS,
  LIST_TUTORIALS,
  LIST_UOMS,
  LIST_HOME_SECTIONS,
  LIST_ABOUT_PAGE,
} from '../constants';

const brandsApi = restApis('brands');
const faqsApi = restApis('faqs');
const featuresApi = restApis('features');
const globalsApi = restApis('globals');
const packsApi = restApis('packs');
const permissionsApi = restApis('permissions');
const rolesApi = restApis('roles');
const tagsApi = restApis('tags');
const teamMembersApi = restApis('team-members');
const tutorialsApi = restApis('tutorials');
const uomsApi = restApis('uoms');
const homeSectionsApi = restApis('home-sections');
const aboutPageApi = restApis('about-page');


export const listBrands = createApiAction(LIST_BRANDS, brandsApi.list);
export const listFaqs = createApiAction(LIST_FAQS, faqsApi.list);
export const listFeatures = createApiAction(LIST_FEATURES, featuresApi.list);
export const listGlobals = createApiAction(LIST_GLOBALS, globalsApi.list);
export const listPacks = createApiAction(LIST_PACKS, packsApi.list);
export const listPermissions = createApiAction(LIST_PERMISSIONS, permissionsApi.list);
export const listRoles = createApiAction(LIST_ROLES, rolesApi.list);
export const listTags = createApiAction(LIST_TAGS, tagsApi.list);
export const listTeamMembers = createApiAction(LIST_TEAM_MEMBERS, teamMembersApi.list);
export const listTutorials = createApiAction(LIST_TUTORIALS, tutorialsApi.list);
export const listUoms = createApiAction(LIST_UOMS, uomsApi.list);
export const listHomeSections = createApiAction(LIST_HOME_SECTIONS, homeSectionsApi.list);
export const listAboutPage = createApiAction(LIST_ABOUT_PAGE, aboutPageApi.list);

